import * as menuAiService from 'services/menuAiService';

export const createAiMenuImport = (payload) => async () => {
  try {
    return await menuAiService.createAiMenuImport(payload);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const getAiMenuImport = (uuid) => async () => {
  try {
    return await menuAiService.getAiMenuImport(uuid);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const retryAiMenuImport = (uuid) => async () => {
  try {
    return await menuAiService.retryAiMenuImport(uuid);
  } catch (err) {
    return Promise.reject(err);
  }
};
